"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleInteriorColor = void 0;
const core_1 = require("@angular/core");
let VehicleInteriorColor = class VehicleInteriorColor {
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], VehicleInteriorColor.prototype, "vehicle", void 0);
VehicleInteriorColor = __decorate([
    (0, core_1.Component)({
        selector: 'vehicle-interior-color',
        template: `
    <span
      class="color-tag"
      [ngClass]="vehicle.vehicleData.features.interiorColor?.color"
    >
      {{ vehicle.vehicleData.features.interiorColor?.manufacturerCode || '-' }}

      <ng-template [ngIf]="vehicle.vehicleData.features.interiorColor?.manufacturerName">
        <svg class="ab-icon cell-icon vmin-tablet-xl"><use xlink:href="#info-light"></use></svg>
        <div class="hover-content">
          {{ vehicle.vehicleData.features.interiorColor?.manufacturerName }}
        </div>
      </ng-template>

      <div class="color-circle" *ngIf="vehicle.vehicleData.features.interiorColor?.color">
        <i class="fa-solid fa-droplet"></i>
      </div>
    </span>
  `,
    })
], VehicleInteriorColor);
exports.VehicleInteriorColor = VehicleInteriorColor;
